<div class="input-container" [class.mod-error]="validate" [class.invalid]="cpFormControl.invalid">
  <input #dateInput
    class="date-input"
    [formControl]="cpFormControl"
    [ngModel]="formattedValue"
    [placeholder]="placeholder"
    (blur)="parseDate()"
    (keyup.enter)="parseDate()"
    (click)="open()" />

  <button type="button" class="date-input-button branding-accent-normal-color" (click)="open()">
    <cp-icon class="date-input-button-icon" icon="calendar">
    </cp-icon>
  </button>
  <input type="text" class="date-picker" #flatpickrElement />
</div>
<cp-validation-error *ngIf="showErrors" [errors]="cpFormControl.errors" [validate]="validate">
</cp-validation-error>
